import styles from "./calendar-legend.module.less";

const CalendarLegend = (props) => {
  const { text } = props;
  return (
    <div className={styles.wrapper}>
      <span className={`${styles.icon} icon-flag`}></span>
      <span>{text}</span>
    </div>
  );
};

export default CalendarLegend;
